import { useEffect, useRef } from 'react';
import { getFeedsData } from '../../../datafetchers/HomePage';
import {
  createRippleEffectRelative,
  getContentType,
} from '../../../Utils/helper';
import { ViewAllButtonVerm } from '../../StoreCategoryPage/ViewAllProducts/styled';
import { fireClickedCTAEvent } from '../../../Utils/useFirebase';

export default function LoadMoreButton(props) {
  let {
    indexToShow,
    setHideLoadMore,
    postContent,
    selectedFilterId,
    showLoader,
    heading,
    mutate,
  } = props;
  const responseRef = useRef();
  const pageCount = useRef(1);
  const perPageCount = useRef(postContent?._meta?.perPage);
  useEffect(() => {
    pageCount.current = 1;
  }, [selectedFilterId]);
  const loadMoreHandler = async () => {
    if (indexToShow + 2 <= postContent?.items?.length) {
      indexToShow = indexToShow + 2;
      const data = {
        questionItemData: postContent,
        indexToShow: indexToShow,
      };
      mutate(data, false);
    } else {
      showLoader(true);
      pageCount.current = pageCount.current + 1;
      indexToShow = indexToShow + 2;
      const feedParams = {
        type: selectedFilterId ? null : 'for_you',
        filter: 'post',
        page: pageCount.current,
        tag: selectedFilterId,
      };
      getFeedsData(feedParams).then((response) => {
        let oldData = postContent?.items;
        responseRef.current = response?.data?.posts?.items;
        perPageCount.current = response?.data?.posts?._meta?.perPage;
        let finalData = [...oldData, ...responseRef.current];
        postContent.items = [...finalData];
        const data = {
          questionItemData: postContent,
          indexToShow: indexToShow,
        };
        mutate(data, false);
        if (responseRef.current?.length < perPageCount.current) {
          setHideLoadMore(true);
        }
        showLoader(false);
      });
    }
  };
  return (
    <ViewAllButtonVerm
      width="300px"
      id="loadCommunity"
      onClick={(e) => {
        createRippleEffectRelative(
          e,
          document.getElementById('loadCommunity'),
          ' black',
        );
        fireClickedCTAEvent(heading, 'Load More', getContentType());
        setTimeout(() => {
          loadMoreHandler();
        }, 400);
      }}
    >
      Load More
    </ViewAllButtonVerm>
  );
}
